import {
    Box,
    Card,
    CardActionArea,
    CardContent,
    Typography,
    useTheme,
} from "@mui/material";

import { Location } from "../../models";

type SimpleLocationCardProps = {
    readonly onClick: CallableFunction;
    readonly location: Location;
};

const SimpleLocationCard = (props: SimpleLocationCardProps) => {
    const { onClick, location } = props;
    const theme = useTheme();
    return (
        <Card
            sx={{
                border: "lightgray 1px solid",
                borderRadius: "0px",
                backgroundColor: `${theme.palette.background.default}`,
            }}
        >
            <CardActionArea onClick={() => onClick()} component="span">
                <CardContent>
                    <Box>
                        <Typography
                            variant="h6"
                            color="info"
                            overflow={"hidden"}
                            textOverflow={"ellipsis"}
                            noWrap
                            textAlign={"start"}
                        >
                            {location?.name}
                        </Typography>
                    </Box>
                </CardContent>
            </CardActionArea>
        </Card>
    );
};

export default SimpleLocationCard;
